var map = {
	"./Canvas.vue": 34742,
	"./DocumentIframe.js": 36334,
	"./Gallery.vue": 77598,
	"./ModeAndViewportToolbar.vue": 18918,
	"./ToolbarTop.vue": 70756,
	"./VersionActions.vue": 19299,
	"./tooltip.js": 21189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48513;